import React, { useState, useEffect, useCallback } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from '../hooks/useAuth';
import Sidebar from '../components/Sidebar';

import Dashboard from './Dashboard';
import Muhasebe from './Muhasebe';
import UstaHesap from './UstaHesap';
import Takvim from './Takvim';
import Santiyeler from './Santiyeler';
import Musteriler from './Musteriler';
import MusteriDetay from './MusteriDetay';
import Calisanlar from './Calisanlar';
import SantiyeDetay from './SantiyeDetay';
import AySonuRaporu from './AySonuRaporu';
import EskiMusteriler from './EskiMusteriler';
import Araclar from './Araclar';

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [ustaBadge, setUstaBadge] = useState(0);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const getSekmeFromPath = useCallback((pathname) => {
    const pathParts = pathname.split('/').filter(Boolean);
    // /admin/muhasebe/usta/123 -> pathParts[1] "muhasebe" olur, böylece sidebar yanmaya devam eder
    if (pathParts.length <= 1) return 'dashboard';
    return pathParts[1]; 
  }, []);

  const [sekme, setSekme] = useState(() => getSekmeFromPath(location.pathname));

  useEffect(() => {
    setSekme(getSekmeFromPath(location.pathname));
  }, [location.pathname, getSekmeFromPath]);

  useEffect(() => {
    const unsub = onSnapshot(collection(db, 'ustaGonderileri'), snap => {
      setUstaBadge(snap.docs.filter(d => !d.data().okundu).length);
    });
    return () => unsub();
  }, []);

  const handleSekmeChange = (id) => {
    navigate(`/admin/${id === 'dashboard' ? '' : id}`);
  };

  return (
    <div className="flex h-screen bg-stone-950 text-white overflow-hidden">
      <Sidebar 
        sekme={sekme}
        setSekme={handleSekmeChange}
        ustaBadge={ustaBadge}
        user={user}
        logout={logout}
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
      />

      <main className={`flex-1 overflow-y-auto transition-all duration-300 pt-16 md:pt-0 ${isCollapsed ? 'md:ml-20' : 'md:ml-64'}`}>
        <div className="max-w-7xl mx-auto p-4 md:p-8">
          <Routes>
            {/* 1. Statik Rotalar */}
            <Route path="/" element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="takvim" element={<Takvim />} />
            <Route path="calisanlar" element={<Calisanlar />} />
            <Route path="rapor" element={<AySonuRaporu />} />
            <Route path="arsiv" element={<EskiMusteriler />} />
            <Route path="araclar" element={<Araclar />} />

            {/* 2. MUHASEBE GRUBU (Önce detay, sonra ana sayfa) */}
            <Route path="muhasebe/usta/:ustaId" element={<UstaHesap />} />
            <Route path="muhasebe" element={<Muhasebe />} />

            {/* 3. MÜŞTERİ GRUBU */}
            <Route path="musteriler/:musteriId" element={<MusteriDetay />} />
            <Route path="musteriler" element={<Musteriler />} />

            {/* 4. ŞANTİYE GRUBU */}
            <Route path="santiyeler/:santiyeId" element={<SantiyeDetay />} />
            <Route path="santiyeler" element={<Santiyeler />} />

            {/* Catch-all */}
            <Route path="*" element={<Dashboard />} />
          </Routes>
        </div>
      </main>
    </div>
  );
}